import { createContext, useContext, useEffect, useState } from 'react'
import { supabase } from '../lib/supabase'
import { useAuth } from './AuthContext'

const TenantContext = createContext()

export const TenantProvider = ({ children }) => {
  const { user } = useAuth()
  const [tenants, setTenants] = useState([])
  const [activeTenant, setActiveTenant] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (user) {
      fetchTenants()
    } else {
      setTenants([])
      setActiveTenant(null)
      setLoading(false)
    }
  }, [user])

  const fetchTenants = async () => {
    try {
      // 1. Fetch existing memberships
      const { data, error } = await supabase
        .from('tenant_members')
        .select('*, tenants(*)')
        .eq('user_id', user.id)

      if (error) throw error

      let userTenants = data.map(tm => tm.tenants)

      // 2. AUTO-CREATE: If user has no tenants (new user), create one
      if (userTenants.length === 0) {
        console.log('Nieuwe gebruiker gedetecteerd. Tenant aanmaken...')

        // A. Create Tenant
        const { data: newTenant, error: createError } = await supabase
          .from('tenants')
          .insert([{
            name: 'Mijn Organisatie',
            plan: 'free' // Start gratis
          }])
          .select()
          .single()

        if (createError) throw createError

        // B. Link User to Tenant (Admin)
        const { error: linkError } = await supabase
          .from('tenant_members')
          .insert([{
            tenant_id: newTenant.id,
            user_id: user.id,
            role: 'admin'
          }])

        if (linkError) throw linkError

        // C. Update local state
        userTenants = [newTenant]
      }

      setTenants(userTenants)

      // Update activeTenant if it exists (refresh with latest data)
      if (activeTenant) {
        const updatedActiveTenant = userTenants.find(t => t.id === activeTenant.id)
        if (updatedActiveTenant) {
          console.log('🔄 Active tenant bijgewerkt met nieuwe data:', updatedActiveTenant)
          setActiveTenant(updatedActiveTenant)
        }
      } else if (userTenants.length > 0) {
        // Set first tenant as active if none selected
        setActiveTenant(userTenants[0])
      }
    } catch (err) {
      console.error('Error fetching/creating tenants:', err)
    } finally {
      setLoading(false)
    }
  }

  return (
    <TenantContext.Provider value={{ tenants, activeTenant, setActiveTenant, loading, refreshTenants: fetchTenants }}>
      {children}
    </TenantContext.Provider>
  )
}

export const useTenant = () => useContext(TenantContext)
